import { Box, Typography, CardContent, Card, Grid } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { formatToIST } from '../../utils/dateFormatter';

const CustomerDetails = () => {
  const location = useLocation();
  const { customer } = location.state || {};

  if (!customer)
    return (
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box sx={{ padding: 4 }}>
            <Typography>No Customer selected</Typography>
          </Box>
        </CardContent>
      </Card>
    );

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <Typography variant="h5" gutterBottom>
              Customer: {customer.name}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 'bold', paddingLeft: 4 }}>
            Personal Details
          </Typography>
          <Box sx={{ padding: 3, paddingLeft: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  First Name:
                </Typography>
                <Typography variant="body1">
                  {customer.name.split(' ')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Last Name:
                </Typography>
                <Typography variant="body1">
                  {customer.name.split(' ').slice(-1)}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Email Address:
                </Typography>
                <Typography variant="body1">{customer.email}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Phone Number:
                </Typography>
                <Typography variant="body1">{customer.phone_no}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Date:
                </Typography>
                <Typography variant="body1">{customer.date ? formatToIST(customer.date) : 'N/A'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Status:
                </Typography>
                <Typography variant="body1">{customer.status}</Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 'bold', paddingLeft: 4 }}>
            Trip Details
          </Typography>
          <Box sx={{ padding: 3, paddingLeft: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Total Trips
                </Typography>
                <Typography variant="body1">10</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Total Earnings
                </Typography>
                <Typography variant="body1">12000</Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 'bold', paddingLeft: 4 }}>
            Shipment Details
          </Typography>
          <Box sx={{ padding: 3, paddingLeft: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Total Shipments
                </Typography>
                <Typography variant="body1">20</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Total Spent
                </Typography>
                <Typography variant="body1">15000</Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default CustomerDetails;
